export enum UserProperty {
    Environment = "env",
    Authenticated = "authenticated",
    OutOfArea = "out_of_area",
    Area = "area",
    Sharer = "sharer",
    Viewer = "viewer",
    Redeemer = "redeemer"
}
